import React from 'react'
import styled from 'styled-components'
import { CardCP } from 'submodules/nerit-framework-ui/common/components/card/CardCP'
import { ButtonCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonCP'
import { TextCP } from 'submodules/nerit-framework-ui/common/components/text/TextCP'

interface ICPProps {
    title: string
    subtitle?: string
    isLoading?: boolean

    /** Atalho para a ferramenta do AQUATEC relacionada ao card. */
    link?: {
        label: string,
        onClick: () => void,
        disabled?: boolean,
    }

    /** Conteúdo extra no canto superior direito (ex.: select). */
    extra?: JSX.Element
    minHeight?: number
    children?: React.ReactNode
}

/**
 * Card padrão do Dashboard: título, conteúdo e atalho para a ferramenta correspondente.
 */
export function DashboardCardCP(props: ICPProps): JSX.Element {

    return (
        <CardCP
            margin={'10px'}
            minHeight={props.minHeight ?? 180}
            isLoading={props.isLoading}
            title={
                <TitleWrapperSCP>
                    {!!props.subtitle && <TextCP text={props.subtitle} color={'#888'} size={'small'}/>}
                    <span>{props.title}</span>
                </TitleWrapperSCP>
            }
            titleRight={
                <>
                    {props.extra}
                    {
                        !!props.link &&
                        <ButtonCP
                            type={'link'}
                            icon={'arrow-right'}
                            onClick={props.link.onClick}
                            disabled={props.link.disabled}
                        >
                            {props.link.label}
                        </ButtonCP>
                    }
                </>
            }
        >
            {props.children}
        </CardCP>
    )
}

const TitleWrapperSCP = styled.div`
    display: flex;
    flex-direction: column;
    white-space: normal;
`
